import { render, staticRenderFns } from "./YouMayAlsoLike.vue?vue&type=template&id=fd1ce8d0&scoped=true&"
import script from "./YouMayAlsoLike.vue?vue&type=script&lang=js&"
export * from "./YouMayAlsoLike.vue?vue&type=script&lang=js&"
import style0 from "./YouMayAlsoLike.vue?vue&type=style&index=0&id=fd1ce8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1ce8d0",
  null
  
)

export default component.exports